'use strict';

export const UPDATE_FILTER = 'organisation/UPDATE_FILTER';
export const DATA_LOADED = 'organisation/DATA_LOADED';
export const MORE_LOADING = 'organisation/MORE_LOADING';
export const MORE_LOADED = 'organisation/MORE_LOADED';
export const IDS_LOADED = 'organisation/IDS_LOADED';
export const LOADING_CANCELLED = 'organisation/LOADING_CANCELLED';
export const LOADING_FAILED = 'organisation/LOADING_FAILED';